module.exports = __webpack_public_path__ + "static/media/English_British_Cynthia BG-32.44d54fce.png";